"use strict";

var _defineProperty = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _toConsumableArray = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/toConsumableArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.onEnter = void 0;

var _requestanimationframeTimer = require("requestanimationframe-timer");

var onEnter = function onEnter(_ref) {
  var node = _ref.node,
      inTransition = _ref.inTransition,
      entryTrigger = _ref.entryTrigger,
      entryProps = _ref.entryProps,
      exitProps = _ref.exitProps,
      triggerResolve = _ref.triggerResolve,
      pathname = _ref.pathname,
      preventScrollJump = _ref.preventScrollJump,
      hash = _ref.hash,
      locationKey = _ref.locationKey,
      _ref$entryProps$delay = _ref.entryProps.delay,
      delay = _ref$entryProps$delay === void 0 ? 0 : _ref$entryProps$delay,
      _ref$appearAfter = _ref.appearAfter,
      appearAfter = _ref$appearAfter === void 0 ? 0 : _ref$appearAfter,
      e = _ref.e;

  if (inTransition && !preventScrollJump) {
    (0, _requestanimationframeTimer.setTimeout)(function () {
      var _window;

      var scrollTo = [0, 0]; // handle hashes that link to ID's
      // for ex /page-2#heading-section

      if (hash) {
        var hashElement = document.getElementById(hash);

        if (hashElement) {
          var clientOffsetTop = hashElement.offsetTop;
          scrollTo = [0, clientOffsetTop];
        }
      }

      (_window = window).scrollTo.apply(_window, _toConsumableArray(scrollTo));
    }, appearAfter);
  } else if (!inTransition) {
    // If session storage fails due to cookies being disabled,
    // scroll to the top after every navigation
    var position = [0, 0];

    try {
      var storageKey = "@@scroll|".concat(pathname, "|").concat(locationKey);
      var y = JSON.parse(sessionStorage.getItem(storageKey)) || 0;
      position = [0, y];
    } catch (e) {
      console.warn("[gatsby-plugin-transition-link] Unable to save state in sessionStorage; sessionStorage is not available.");
    } finally {
      var _window2;

      (_window2 = window).scrollTo.apply(_window2, _toConsumableArray(position));
    }
  }

  if (!inTransition) return;

  var removed = entryProps.trigger,
      entryPropsTrimmed = _objectWithoutProperties(entryProps, ["trigger"]);

  var timeout = appearAfter + delay;
  var visiblePromise = new Promise(function (resolve) {
    (0, _requestanimationframeTimer.setTimeout)(function () {
      return resolve();
    }, timeout);
  });
  triggerResolve.entry(_objectSpread(_objectSpread({}, entryPropsTrimmed), {}, {
    visible: visiblePromise,
    node: node
  }));
  entryTrigger && typeof entryTrigger === 'function' && entryTrigger({
    entry: entryProps,
    exit: exitProps,
    node: node,
    e: e
  });
};

exports.onEnter = onEnter;